
const formatTime = (time) => {
    /*
        parameters:
            time: str, expects time in 24 hr format 24:59

        returs:
            str: time in am/pm format
    */

    if (!time) return "";

    // normalize case and whitespace
    const t = time.toLowerCase().trim();
    
    // split off the hour and the rest
    let [hourPart, minutePart] = t.split(":");
    let suffix = "";
    let minutes = minutePart;
    
    // detect am/pm and strip the letter
    if (minutePart.includes("pm")) {
        suffix = "pm";
        minutes = minutePart.replace("pm", "").trim();
    } else if (minutePart.includes("am")) {
        suffix = "am";
        minutes = minutePart.replace("am", "").trim();
    }
    
    // parse hour as number
    let hour = parseInt(hourPart, 10);
    
    // if no suffix but hour>=12, assume pm; else am
    if (!suffix) {
        suffix = hour >= 12 ? "pm" : "am";
    }
    
    // convert 24h to 12h
    if (hour > 12) {
        hour = hour - 12;
    } else if (hour === 0) {
        hour = 12; // midnight hour
    }
    
    // ensure minutes are two digits
    minutes = minutes.padStart(2, "0");
    
    return `${hour}:${minutes} ${suffix}`;
}

  export default formatTime;